import api from "../utils/api";

export const getTrainingList = async (currentPage: number, elementsByPage: number) => {
    try {
        const params: any = {
            populate: '*',
            sort: 'createdAt:desc',
            pagination: {
                limit: elementsByPage,
                start: currentPage,
            },
        };

        const res = await api.get(`/api/trainings`, {params});
        return res.data;

    } catch (e) {
        console.error(e);
        throw e;
    }
}

export const getTrainingById = async (trainingId: string) => {
    try {        
        const res = await api.get(`/api/trainings/${trainingId}`, {
            params: {
                populate: ['image'],
            }
        });
        return res.data.data;

    } catch (e) {
        console.error(e);
        throw e;
    }
}